import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axiosInstance";

// Fetch Countries
export const fetchCountries = createAsyncThunk(
  "master/countries",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/master/countries");
      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to load countries");
    }
  }
);

// Fetch States by Country
export const fetchStates = createAsyncThunk(
  "master/states",
  async (countryId, { rejectWithValue }) => {
    try {
      const res = await api.get(`/api/master/states?countryId=${countryId}`);
      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to load states");
    }
  }
);

// Fetch Districts by State
export const fetchDistricts = createAsyncThunk(
  "master/districts",
  async (stateId, { rejectWithValue }) => {
    try {
      const res = await api.get(`/api/master/districts?stateId=${stateId}`);
      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to load districts");
    }
  }
);

// Fetch Local Areas by District
export const fetchLocalAreas = createAsyncThunk(
  "master/localAreas",
  async (districtId, { rejectWithValue }) => {
    try {
      const res = await api.get(`/api/master/local-areas?districtId=${districtId}`);
      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to load local areas");
    }
  }
);


// Fetch Business Types
export const fetchBusinessTypes = createAsyncThunk(
  "master/businessTypes",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/master/business-types");
      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Failed to load business types"
      );
    }
  }
);

// Fetch Business Categories
export const fetchBusinessCategories = createAsyncThunk(
  "master/businessCategories",
  async (businessTypeId, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/master/business-categories", {
        params: { businessTypeId },
      });
      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { message: "Failed to fetch business categories" }
      );
    }
  }
);

// Fetch Business Services
export const fetchBusinessServices = createAsyncThunk(
  "master/businessServices",
  async (businessTypeId, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/master/business-services", {
        params: { businessTypeId },
      });
      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { message: "Failed to fetch business services" }
      );
    }
  }
);